export default "__VITE_ASSET__2e6302a9__"